import moment from 'moment';
import PortalTooltip from '../../common/PortalTooltip';
import { Time } from '../../common/MomentTime';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCircleXmark } from '@fortawesome/pro-light-svg-icons';

//θ(1) Returns all the columns of the datagrid
export const getColumns = ({ id }) => {
  return [
    {
      field: 'STATUS',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => {
        const isError = params.row.STATUS === 'FAILED';
        const isSuccess = params.row.STATUS === 'SUCCESS';
        return (
          <>
            {(isError || isSuccess) && (
              <PortalTooltip id={`${id}__tooltip_status`} title={isError ? 'Error' : 'Success'}>
                <FontAwesomeIcon
                  id={`${id}__icon_status`}
                  size="lg"
                  icon={isError ? faCircleXmark : faCheckCircle}
                  className={isError ? 'myOdu__error' : 'myOdu__success'}
                />
              </PortalTooltip>
            )}
          </>
        );
      },
    },
    {
      field: 'CREATED_AT',
      headerName: 'Time',
      width: 225,
      valueFormatter: (value) => {
        return Time.University(value).format('MMMM D, YYYY, h:mm A');
      },
    },
    {
      field: 'ACTION',
      headerName: 'Action',
      width: 250,
    },
    {
      field: 'MIDAS',
      headerName: 'Taken By',
      width: 100,
    },
    {
      field: 'DESCRIPTION',
      headerName: 'Description',
      width: 400,
    },
    {
      field: 'REASON',
      headerName: 'Reason',
      width: 400,
      valueGetter: (value, row) => value?.message,
    },
  ];
};
